module.exports = __webpack_public_path__ + "static/media/mision-ico.db227ad4.svg";